angular.module('impactx.approvalincomplete').controller('IncompleteApprovalCtrl', IncompleteApprovalCtrl);
IncompleteApprovalCtrl.$inject = [
    '$scope',
    'dataGen',
    'BackService',
    '$mdToast',
    '$routeParams',
    'TranslationService',
    'ToastService',
    '$controller',
    '$route',
    'ToolbarService'
];

function IncompleteApprovalCtrl($scope, dataGen, BackService, $mdToast, $routeParams, TranslationService, ToastService, $controller, $route, ToolbarService) {
    $controller('ApprovalDetailCtrl', {$scope: $scope, backRoute: null});

    var ctrl = this;

    var canDelegateAll = function () {
        return isNothingSelected() && $scope.data.approval.hasRightToDelegate;
    };

    var canDelegateContract = function () {
        return isContractSelected() && $scope.data.approval.hasRightToDelegate;
    };

    var canDelegateItem = function () {
        return isItemSelected() && $scope.data.approval.hasRightToDelegate && $scope.selectedItems[0].status === 0;
    };

    var isNothingSelected = function () {
        return $scope.selectedItems.length === 0 && $scope.selectedContractHeader.length === 0;
    };

    var isContractSelected = function () {
        return $scope.selectedContractHeader.length > 0 && $scope.selectedItems.length === 0;
    };

    var isItemSelected = function () {
        return $scope.selectedContractHeader.length === 0 && $scope.selectedItems.length > 0;
    };

    ctrl.clearSelection = function () {
        $scope.selectedItems = [];
        $scope.selectedContractHeader = [];
    };

    $scope.getHeaderTable = function () {
        if ($scope.data.docType === 1) {
            return "prh";
        }
        else if ($scope.data.docType === 2) {
            return "deh"
        }
    };

    $scope.getDataForItemAction = function () {
        if ($scope.data.docType === 1) {
            return {
                PRH_Id: $scope.data.approval.headerId,
                PRI_Ids: $scope.selectedItems,
                type: "pri",
                id: $scope.data.approval.id
            };
        }
        else if ($scope.data.docType === 2) {
            return {
                DEH_Id: $scope.data.approval.headerId,
                DEI_Ids: $scope.selectedItems,
                type: "dei",
                id: $scope.data.approval.id
            };
        }
    };

    $scope.getDataForCSCAction = function (csc_id, supplierHeaderId) {
        if ($scope.data.docType === 1) {
            return {
                PRH_Id: $scope.data.approval.headerId,
                CSC_Id: csc_id,
                PRS_Id: supplierHeaderId,
                type: "prs",
                id: $scope.data.approval.id
            };
        }
        else if ($scope.data.docType === 2) {
            return {
                DEH_Id: $scope.data.approval.headerId,
                CSC_Id: csc_id,
                DES_Id: supplierHeaderId,
                type: "des",
                id: $scope.data.approval.id
            };
        }
    };

    $scope.getDataForHeaderAction = function () {
        if (!$scope.data.useRightNotification) {
            return $scope.getDataForCSCAction($scope.data.approval.contracts[0].id, $scope.data.approval.contracts[0].supplierHeaderId);
        }
        if ($scope.data.docType === 1) {
            return {
                PRH_Id: $scope.data.approval.headerId,
                type: "prh",
                id: $scope.data.approval.id
            };
        }
        else if ($scope.data.docType === 2) {
            return {
                DEH_Id: $scope.data.approval.headerId,
                type: "deh",
                id: $scope.data.approval.id
            };
        }
    };

    $scope.getDataForItemActionOneItem = function (item) {
        if ($scope.data.docType === 1) {
            return {
                PRH_Id: $scope.data.approval.headerId,
                PRI_Ids: [{id: item.id}],
                type: "pri",
                id: $scope.data.approval.id
            };
        }
        else if ($scope.data.docType === 2) {
            return {
                DEH_Id: $scope.data.approval.headerId,
                DEI_Ids: [{id: item.id}],
                type: "dei",
                id: $scope.data.approval.id
            };
        }
    };

    $scope.callDelegateEntryPoint = function (data, callback) {
        $scope.saveData(null, true).then(function () {
            dataGen.post($scope, data, "/approvalincomplete/delegate", function (data) {
                $scope.handleControlDataForChips();
                $scope.showPostToast($scope.trns.saveSuccess);
                ctrl.clearSelection();
                $route.reload();
            })
        });
    };

    $scope.getDelegationUserEntryPoint = function () {
        return "/approvalincomplete/delegationuser";
    };

    ctrl.getData = function () {
        var paramObj = {
            id: $routeParams.id
        };
        dataGen.getData($scope, paramObj, '/approvalincomplete/view').then(function () {
            $scope.setButtons();
        });
    };

    $scope.setButtons = function () {
        $scope.buttonDefinition = [
            // header buttons
            {
                label: $scope.trns.comments,
                action: $scope.toggleComments,
                type: 'dialogaction',
                condition: isNothingSelected
            },
            {
                label: $scope.trns.delegate,
                action: $scope.delegateAll,
                type: 'validation',
                condition: canDelegateAll,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.comments,
                action: $scope.toggleSupplierComments,
                type: 'dialogaction',
                condition: isContractSelected
            },
            {
                label: $scope.trns.delegate,
                action: $scope.delegateCSC,
                type: 'validation',
                condition: canDelegateContract,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.comments,
                action: $scope.toggleItemComments,
                type: 'dialogaction',
                condition: isItemSelected
            },
            {
                label: $scope.trns.delegate,
                action: $scope.delegateItems,
                type: 'validation',
                condition: canDelegateItem,
                params: {
                    form: $scope.dialogData
                }
            }
        ];
        ToolbarService.setButtons($scope.buttonDefinition);
    };

    ctrl.getData();
}